import { log } from "video.js";
import apiHttpClient from "./ApiHttpClient";

export default class AsahiAccessLogRepository {
  /**
   * createAsahiAccessLog
   * @param {string} pagePath
   * @returns {Promise}
   */
  async createAsahiAccessLog(pagePath) {
    console.log(pagePath);

    try {
      const res = await apiHttpClient.post(
        `asahi_access_log/create`,
        { page_path: pagePath }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
